function normalizeText(value) {
  return String(value || '').trim();
}

function normalizeNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function normalizeAudienceFilters(filters = {}) {
  return {
    countries: Array.isArray(filters?.countries) ? [...new Set(filters.countries.map((item) => normalizeText(item).toUpperCase()).filter(Boolean))] : [],
    profileStatuses: Array.isArray(filters?.profileStatuses) ? filters.profileStatuses.map(normalizeText).filter(Boolean) : [],
    languages: Array.isArray(filters?.languages) ? [...new Set(filters.languages.map((item) => normalizeText(item).toLowerCase()).filter(Boolean))] : [],
  };
}

export function buildEmptyMarketingEmailProviderConnectionForm() {
  return {
    provider: 'brevo',
    displayName: '',
    apiKey: '',
    apiBaseUrl: '',
    defaultListId: '',
    enabled: true,
  };
}

export function buildMarketingEmailProviderConnectionPayloadFromForm(form) {
  const apiKey = normalizeText(form?.apiKey);

  return {
    provider: normalizeText(form?.provider || 'brevo') || 'brevo',
    displayName: normalizeText(form?.displayName),
    apiKey: apiKey || null,
    apiBaseUrl: normalizeText(form?.apiBaseUrl) || null,
    defaultListId: normalizeText(form?.defaultListId) || null,
    enabled: Boolean(form?.enabled ?? true),
  };
}

export function validateMarketingEmailProviderConnectionPayload(payload) {
  const errors = {};

  if (!normalizeText(payload?.provider)) {
    errors.provider = 'Provider is required.';
  }

  if (!normalizeText(payload?.displayName)) {
    errors.displayName = 'Display name is required.';
  }

  return errors;
}

export function mapMarketingEmailProviderConnectionDto(item = {}) {
  return {
    uid: normalizeText(item?.uid),
    provider: normalizeText(item?.provider),
    displayName: normalizeText(item?.displayName),
    enabled: Boolean(item?.enabled),
    configured: Boolean(item?.configured),
    defaultListId: item?.defaultListId === null || item?.defaultListId === undefined ? null : normalizeText(item.defaultListId),
    apiBaseUrl: item?.apiBaseUrl === null || item?.apiBaseUrl === undefined ? null : normalizeText(item.apiBaseUrl),
    createdAt: item?.createdAt || null,
    updatedAt: item?.updatedAt || null,
  };
}

export function mapMarketingEmailProviderConnectionResponseToDto(response = {}) {
  return mapMarketingEmailProviderConnectionDto(response?.connection || response);
}

export function mapMarketingEmailProviderConnectionListResponseToDto(response = {}) {
  const connections = Array.isArray(response?.connections) ? response.connections : [];

  return {
    connections: connections.map(mapMarketingEmailProviderConnectionDto),
  };
}

export function buildMarketingEmailSyncDryRunPayload(filters) {
  return {
    audienceFilters: normalizeAudienceFilters(filters),
  };
}

export function buildMarketingEmailSyncJobPayload({ connectionUid, targetListId, audienceFilters } = {}) {
  return {
    connectionUid: normalizeText(connectionUid),
    targetListId: normalizeText(targetListId) || null,
    audienceFilters: normalizeAudienceFilters(audienceFilters),
  };
}

export function mapMarketingEmailSyncJobDto(item = {}) {
  return {
    uid: normalizeText(item?.uid),
    connectionUid: normalizeText(item?.connectionUid),
    provider: normalizeText(item?.provider),
    targetListId: normalizeText(item?.targetListId),
    audienceFilters: item?.audienceFilters && typeof item.audienceFilters === 'object' ? item.audienceFilters : {},
    status: normalizeText(item?.status || 'pending') || 'pending',
    selectedCount: normalizeNumber(item?.selectedCount),
    syncedCount: normalizeNumber(item?.syncedCount),
    failedCount: normalizeNumber(item?.failedCount),
    skippedCount: normalizeNumber(item?.skippedCount),
    errorSummary: item?.errorSummary && typeof item.errorSummary === 'object' ? item.errorSummary : {},
    startedAt: item?.startedAt || null,
    completedAt: item?.completedAt || null,
    createdAt: item?.createdAt || null,
  };
}

export function mapMarketingEmailSyncJobListResponseToDto(response = {}) {
  const jobs = Array.isArray(response?.jobs) ? response.jobs : [];

  return {
    jobs: jobs.map(mapMarketingEmailSyncJobDto),
  };
}

export function mapMarketingEmailSettingsResponseToDto(response = {}) {
  return {
    defaultBatchSize: normalizeNumber(response?.defaultBatchSize || 100),
    unsubscribeFooterText: normalizeText(response?.unsubscribeFooterText),
  };
}

export function buildMarketingEmailSettingsPayloadFromForm(form = {}) {
  return {
    defaultBatchSize: normalizeNumber(form?.defaultBatchSize),
    unsubscribeFooterText: normalizeText(form?.unsubscribeFooterText),
  };
}

export function validateMarketingEmailSettingsPayload(payload = {}) {
  const errors = {};
  const batchSize = Number(payload?.defaultBatchSize);
  const footerText = normalizeText(payload?.unsubscribeFooterText);

  if (!Number.isInteger(batchSize) || batchSize < 1 || batchSize > 1000) {
    errors.defaultBatchSize = 'Batch size must be between 1 and 1000.';
  }

  if (!footerText.includes('{{unsubscribeUrl}}')) {
    errors.unsubscribeFooterText = 'Footer must include {{unsubscribeUrl}}.';
  }

  return errors;
}
